import {registerApi, Visio2Api} from '/vodalys/visio2/api'

async function getVonageVisio2Api():Promise<Visio2Api> {
    
    const {VonageVisio2Api} = await import('./vonage.api.visio2api')
    return VonageVisio2Api.getInstance()
}


registerApi('visio2:vonage_api', getVonageVisio2Api)


// import './src/debugTools'